 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin-manage-archive-list~admin-manage-article-list~admin-manage-article-save~page":"admin-manage-archive-list~admin-manage-article-list~admin-manage-article-save~page","admin-manage-archive-list~page":"admin-manage-archive-list~page","admin-manage-archive-list":"admin-manage-archive-list","page":"page","admin-manage-article-save":"admin-manage-article-save","admin-manage-article-list":"admin-manage-article-list","admin-manage-customer-list":"admin-manage-customer-list","admin-manage-customer-save":"admin-manage-customer-save","admin-manage-dashboard-list":"admin-manage-dashboard-list","admin-manage-organizations-list":"admin-manage-organizations-list","admin-manage-role-list":"admin-manage-role-list","admin-manage-role-save":"admin-manage-role-save","admin-manage-symbols-list":"admin-manage-symbols-list","admin-manage-user-list":"admin-manage-user-list","admin-manage-user-save":"admin-manage-user-save","admin-manage-widget-list~startPage":"admin-manage-widget-list~startPage","admin-manage-widget-list":"admin-manage-widget-list","startPage":"startPage","control-print-view":"control-print-view","do-control~manage-building":"do-control~manage-building","do-control":"do-control","manage-building":"manage-building","error-view":"error-view","globalpage":"globalpage","import-buildings":"import-buildings","log-table":"log-table","manage-building-list":"manage-building-list"}[chunkId]||chunkId) + "." + {"admin-manage-archive-list~admin-manage-article-list~admin-manage-article-save~page":"30dbea8a","admin-manage-archive-list~page":"ded9c801","admin-manage-archive-list":"bb95adef","page":"386c25f3","admin-manage-article-save":"e21a7f8a","admin-manage-article-list":"9b83c64a","admin-manage-customer-list":"98ac6051","admin-manage-customer-save":"880a353a","admin-manage-dashboard-list":"b8d1ee19","admin-manage-organizations-list":"0ef47dcf","admin-manage-role-list":"2f4bbbf1","admin-manage-role-save":"e589f795","admin-manage-symbols-list":"93cbc165","admin-manage-user-list":"d55cef1f","admin-manage-user-save":"9a98c3a3","admin-manage-widget-list~startPage":"d0016905","admin-manage-widget-list":"d1505563","startPage":"6b391820","control-print-view":"b755a57b","do-control~manage-building":"06017fea","do-control":"06e65e25","manage-building":"b405d3bf","error-view":"b58deb34","globalpage":"dca58185","import-buildings":"c2d2780a","log-table":"f717733a","manage-building-list":"4465b752"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin-manage-archive-list~page":1,"admin-manage-archive-list":1,"page":1,"admin-manage-article-save":1,"admin-manage-article-list":1,"admin-manage-customer-list":1,"admin-manage-customer-save":1,"admin-manage-dashboard-list":1,"admin-manage-organizations-list":1,"admin-manage-role-list":1,"admin-manage-role-save":1,"admin-manage-symbols-list":1,"admin-manage-user-list":1,"admin-manage-user-save":1,"admin-manage-widget-list~startPage":1,"admin-manage-widget-list":1,"startPage":1,"control-print-view":1,"do-control~manage-building":1,"do-control":1,"manage-building":1,"globalpage":1,"log-table":1,"manage-building-list":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin-manage-archive-list~admin-manage-article-list~admin-manage-article-save~page":"admin-manage-archive-list~admin-manage-article-list~admin-manage-article-save~page","admin-manage-archive-list~page":"admin-manage-archive-list~page","admin-manage-archive-list":"admin-manage-archive-list","page":"page","admin-manage-article-save":"admin-manage-article-save","admin-manage-article-list":"admin-manage-article-list","admin-manage-customer-list":"admin-manage-customer-list","admin-manage-customer-save":"admin-manage-customer-save","admin-manage-dashboard-list":"admin-manage-dashboard-list","admin-manage-organizations-list":"admin-manage-organizations-list","admin-manage-role-list":"admin-manage-role-list","admin-manage-role-save":"admin-manage-role-save","admin-manage-symbols-list":"admin-manage-symbols-list","admin-manage-user-list":"admin-manage-user-list","admin-manage-user-save":"admin-manage-user-save","admin-manage-widget-list~startPage":"admin-manage-widget-list~startPage","admin-manage-widget-list":"admin-manage-widget-list","startPage":"startPage","control-print-view":"control-print-view","do-control~manage-building":"do-control~manage-building","do-control":"do-control","manage-building":"manage-building","error-view":"error-view","globalpage":"globalpage","import-buildings":"import-buildings","log-table":"log-table","manage-building-list":"manage-building-list"}[chunkId]||chunkId) + "." + {"admin-manage-archive-list~admin-manage-article-list~admin-manage-article-save~page":"31d6cfe0","admin-manage-archive-list~page":"54e61991","admin-manage-archive-list":"9233ea8b","page":"0245a580","admin-manage-article-save":"c1c5492a","admin-manage-article-list":"09e19aec","admin-manage-customer-list":"f7cab538","admin-manage-customer-save":"ad0f4d73","admin-manage-dashboard-list":"c82e2559","admin-manage-organizations-list":"8e0db4e2","admin-manage-role-list":"09e19aec","admin-manage-role-save":"89977d5e","admin-manage-symbols-list":"11f9c412","admin-manage-user-list":"0f8713c8","admin-manage-user-save":"ccac99a2","admin-manage-widget-list~startPage":"7606b429","admin-manage-widget-list":"5059face","startPage":"853e264a","control-print-view":"b853ff5c","do-control~manage-building":"3b52537d","do-control":"d968b5d9","manage-building":"96ae7304","error-view":"31d6cfe0","globalpage":"bb8cd49b","import-buildings":"31d6cfe0","log-table":"127db525","manage-building-list":"b352031a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
